import { req } from 'vuelidate/lib/validators/common'
import { withParams } from 'vuelidate'

export default (min) =>
  withParams({ type: 'minWord' }, value => !req(value) ||
    value.split(' ').filter((v) => v !== (undefined || null || '')).length >= min)
